<template>
  <div
    class="mobile-margin"
  >
    <div style="display: none;">
      <div
        id="pin"
        class="text-center"
      >
        <v-icon
          v-blur
          x-large
          color="red"
        >
          mdi-map-marker
        </v-icon>
      </div>
    </div>
    <v-dialog
      v-model="requestLimitReached"
      persistent
      max-width="350"
    >
      <v-card>
        <div class="text-right me-1">
          <v-icon
            color="red"
            size="28"
            @click="resetDrawer()"
          >
            mdi-close
          </v-icon>
        </div>
        <v-card-title class="text-h5">
          {{ $t('TicketingLimit.title') }}
        </v-card-title>
        <v-card-text>
          {{ $t('TicketingLimit.description') }}
        </v-card-text>
        <v-card-actions>
          <v-btn
            to="/contacts"
            color="green darken-1"
            text
          >
            {{ $t('NavigationSideBar.contacts') }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="$router.push({
              name: 'TicketingRequestList',
              params: { id: service_id }
            })"
          >
            {{ $t('TicketingTable.title') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>

    <v-card
      id="rightBar"
      class="top-component-class pa-0 ma-0"
    >
      <v-card-title
        class="ticketing-card-title ma-0 d-flex justify-space-between"
        color="black"
      >
        {{ $t('Ticketing.title') }}
        <!-- <v-icon
          color="red"
          size="30"
          @click="resetDrawer()"
        >
          mdi-close
        </v-icon> -->
      </v-card-title>
      <div class="slider">
        <v-form
          v-model="valid"
          lazy-validation
        >
          <v-card-text :class="!mobileBreakpoints() ? 'mt-2' : ''">
            <span class="ticketing-card-subtitle">
              <b>{{ $t('Ticketing.select') }}</b>
            </span>
            <v-row>
              <v-col
                cols="12"
                md="6"
                class="d-flex pb-0"
              >
                <v-select
                  v-model="selectedDocumentTypes"
                  :items="documentTypesList"
                  :item-text="item => $t(`ServiceCard.${ticket_id}.${item.document_id}.documentType`)"
                  :label="$t('Ticketing.documentType') + '*'"
                  prepend-icon="mdi-file-document-edit-outline"
                  return-object
                  @change="disableMarker()"
                >
                  <!-- <template v-slot:item="{ item }">
                    {{ $t(item) }}
                  </template>
                  <template v-slot:selection="{ item }">
                    {{ $t(item) }}
                  </template> -->
                </v-select>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      class="ml-2"
                      color="green darken-1"
                      v-on="on"
                    >
                      mdi-information-variant-circle-outline
                    </v-icon>
                  </template>
                  <div
                    class="my-1"
                    :style="{ 'max-width': '400px' }"
                  >
                    <span v-if="selectedTooltipDataDocument.title">
                      <b>{{ selectedTooltipDataDocument.title }}:</b> <br> {{ selectedTooltipDataDocument.text }}
                    </span>
                    <span v-else>
                      {{ tooltipNoSelection }}
                    </span>
                  </div>
                </v-tooltip>
              </v-col>
              <v-col
                cols="12"
                md="6"
                class="d-flex pb-0"
              >
                <v-select
                  v-model="selectedMeteoTypes"
                  :items="meteoTypesList"
                  :item-text="item => $t(`ServiceCard.${ticket_id}.${item.meteo_id}.meteoType`)"
                  :label="$t('Ticketing.meteoType') + '*'"
                  prepend-icon="mdi-cloud-outline"
                  return-object
                  @change="updateMeteoType()"
                >
                  <!-- <template v-slot:item="{ item }">
                    {{ $t(item) }}
                  </template>
                  <template v-slot:selection="{ item }">
                    {{ $t(item) }}
                  </template> -->
                </v-select>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      class="ml-2"
                      color="green darken-1"
                      v-on="on"
                    >
                      mdi-information-variant-circle-outline
                    </v-icon>
                  </template>
                  <div
                    class="my-1"
                    :style="{ 'max-width': '400px' }"
                  >
                    <span v-if="selectedTooltipDataMeteo.title">
                      <b>{{ selectedTooltipDataMeteo.title }}:</b>
                      <!-- eslint-disable-next-line vue/no-v-html -->
                      <span v-html="formatTooltipText(selectedTooltipDataMeteo.text)" />
                    </span>
                    <span v-else>
                      {{ tooltipNoSelection }}
                    </span>
                  </div>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-menu
              ref="rangeMenu"
              v-model="rangeMenu"
              :close-on-content-click="false"
              :return-value.sync="rangeDate"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="rangeDateText"
                  multiple
                  chips
                  small-chips
                  :label="$t('Ticketing.rangeDate') + '*'"
                  prepend-icon="mdi-calendar"
                  readonly
                  :disabled="Object.keys(selectedMeteoTypes).length === 0"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="rangeDate"
                no-title
                range
                scrollable
                :min="rangeDate[0]"
                :max="getCalendarMaxDate()"
                :locale="app_user.app_user_data[0].language"
                first-day-of-week="1"
              >
                <div
                  class="d-flex flex-column mx-auto"
                  style="width: 100%"
                >
                  <div
                    v-if="!isRelazione"
                    class="d-flex justify-center caption text--secondary"
                    style="height: 20px"
                  >
                    <v-icon size="18">
                      mdi-information-variant
                    </v-icon>
                    <p>
                      {{ calendarInfoText }}
                    </p>
                  </div>
                  <div class="d-flex justify-space-between">
                    <v-btn
                      text
                      color="primary"
                      @click="closeDateRange()"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      :disabled="rangeDate.length < 2"
                      @click="$refs.rangeMenu.save(rangeDate)"
                    >
                      OK
                    </v-btn>
                  </div>
                </div>
              </v-date-picker>
            </v-menu>
            <div class="mt-4 ticketing-card-subtitle d-flex justify-space-between">
              <b>{{ $t('Ticketing.geo') }}</b>
              <span
                v-if="isRelazione || isPuntuale"
                class="d-flex mt-n1"
              >
                <v-switch
                  v-model="isDatiCatastaliVisible"
                  dense
                  hide-details
                  color="#0da344"
                  label="Mostra dati catastali"
                  class="mt-0"
                  @change="handleDatiCatastali"
                />
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      class="ml-2"
                      color="green darken-1"
                      v-on="on"
                    >
                      mdi-information-variant-circle-outline
                    </v-icon>
                  </template>
                  <div
                    class="my-1"
                    :style="{ 'max-width': '400px' }"
                  >
                    <span>
                      <!-- {{ $t('Ticketing.tooltipCoordinate') }} -->
                      Con la selezione della voce “Mostra dati catastali” compariranno, sulla mappa, i layer messi a disposizione dall’Agenzia delle Entrate per l’identificazione catastale di un bene immobile, terreno o fabbricato. Tali dati sono aggiornati all’anno corrente. La visualizzazione iniziale su mappa permette di osservare solo i fogli catastali con relativi numeri e forme. Ingrandendo la mappa attraverso la funzione zoom, sarà possibile visualizzare anche le particelle catastali con relativi numeri e forme.
                    </span>
                  </div>
                </v-tooltip>
              </span>
            </div>
            <div v-if="!showMaxLimitMsg">
              <v-radio-group
                v-model="selectedAddressType"
                row
                mandatory
                @change="resetAddress()"
              >
                <v-radio
                  :label="$t('Ticketing.address')"
                  :ripple="true"
                  value="Address"
                  color="#0da344"
                />
                <v-radio
                  v-if="isRelazione || isPuntuale"
                  :label="$t('Ticketing.marker')"
                  :ripple="true"
                  value="Manual"
                  color="#0da344"
                  @click="isManualCoordinates = true"
                />
                <v-tooltip
                  v-if="isManualCoordinates"
                  bottom
                >
                  <template v-slot:activator="{ on }">
                    <v-icon
                      class="ml-2"
                      color="green darken-1"
                      v-on="on"
                    >
                      mdi-information-variant-circle-outline
                    </v-icon>
                  </template>
                  <div
                    class="my-1"
                    :style="{ 'max-width': '400px' }"
                  >
                    <span>
                      {{ $t('Ticketing.tooltipCoordinate') }}
                    </span>
                  </div>
                </v-tooltip>
                <v-radio
                  v-if="isRelazione || isPuntuale"
                  :label="$t('Ticketing.cadastral')"
                  :ripple="true"
                  value="Cadastral"
                  color="#0da344"
                  @click="isCadastralCoordinates = true"
                />
                <v-tooltip
                  v-if="isCadastralCoordinates"
                  bottom
                >
                  <template v-slot:activator="{ on }">
                    <v-icon
                      class="ml-2"
                      color="green darken-1"
                      v-on="on"
                    >
                      mdi-information-variant-circle-outline
                    </v-icon>
                  </template>
                  <div
                    class="my-1"
                    :style="{ 'max-width': '400px' }"
                  >
                    <span>
                      <!-- {{ $t('Ticketing.tooltipCadastral') }} -->
                      Dati catastali da fonti ufficiali (Agenzia delle Entrate e Catasto/Libro Fondiario di Trento e Bolzano): inserendo provincia catastale, comune catastale, foglio ed eventuale particella (oppure la sola particella per il Trentino-Alto Adige), il sistema restituisce le coordinate geografiche in gradi decimali (latitudine °N e longitudine °E) del centroide del pixel in cui ricade l'unità catastale (da aggiungere alla lista dei punti richiesti).
                    </span>
                  </div>
                </v-tooltip>
              </v-radio-group>
              <div v-if="selectedAddressType === 'Address'">
                <v-autocomplete
                  v-if="isComunale || isProvinciale"
                  v-model="selectedAddressFromSelect"
                  class="ma-0"
                  :items="ticketing.comuniProvince"
                  label="Seleziona un comune o una provincia"
                  :disabled="Object.keys(selectedMeteoTypes).length === 0"
                  @change="getCoordinatesFromAddress()"
                />
                <input
                  v-else
                  ref="autocomplete"
                  :placeholder="$t('Ticketing.searchBox')"
                  class="search-location"
                  :disabled="Object.keys(selectedMeteoTypes).length === 0"
                  onfocus="value = ''"
                  type="text"
                  @click="autocompleteInit()"
                >
              </div>
              <v-row v-if="selectedAddressType === 'Manual'">
                <v-col
                  cols="6"
                  class="pb-0"
                >
                  <v-text-field
                    id="lat"
                    v-model="latitude"
                    :label="$t('Ticketing.latitude')"
                    :rules="number_rules"
                    @keyup="invalidateResolvedLocation()"
                  />
                </v-col>
                <v-col
                  cols="6"
                >
                  <v-text-field
                    id="lng"
                    v-model="longitude"
                    :label="$t('Ticketing.longitude')"
                    :rules="number_rules"
                    @keyup="invalidateResolvedLocation()"
                  />
                </v-col>
              </v-row>
              <div v-if="selectedAddressType === 'Cadastral'">
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    class="d-flex pb-0"
                  >
                    <v-autocomplete
                      v-model="selectedRegionProvince"
                      :search-input.sync="regionProvinceSearch"
                      :items="filteredCadastralItems"
                      item-text="text"
                      item-value="value"
                      :label="$t('Ticketing.cadastralSelectProvince')"
                      item-disabled="disabled"
                      return-object
                      clearable
                      @click:clear="resetCadastralData('RegionProvince')"
                      @change="val => { if (val) fillCadastralDataSelect('RegionProvince'); regionProvinceSearch = ''; }"
                    >
                      <!-- SLOT ITEM (dropdown) -->
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title
                            :class="{
                              'font-weight-bold': item.disabled,
                              'pl-4': !item.disabled
                            }"
                          >
                            {{ item.text }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>

                      <!-- SLOT SELECTION (campo selezionato) -->
                      <template v-slot:selection="{ item }">
                        <span>{{ item.text }}</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    class="d-flex pb-0"
                  >
                    <v-autocomplete
                      v-model="selectedMunicipality"
                      :items="cadastral_data.municipality_list"
                      :item-text="item => `${item.name}`"
                      item-value="code"
                      :label="$t('Ticketing.cadastralSelectMunicipality')"
                      return-object
                      clearable
                      :disabled="!selectedRegionProvince"
                      @click:clear="resetCadastralData('Municipality')"
                      @change="val => val && fillCadastralDataSelect('Municipality')"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    class="d-flex pb-0"
                  >
                    <v-autocomplete
                      v-model="selectedSheet"
                      :items="orderedSheets"
                      :item-text="item => getSheetLabel(item)"
                      item-value="sheetId"
                      :label="$t('Ticketing.cadastralSelect') + ' ' + $t('Ticketing.cadastralSheet')"
                      :placeholder="isTnBzCadastralFlow ? 'Non applicabile per questo catasto' : ''"
                      persistent-placeholder
                      return-object
                      clearable
                      :disabled="!selectedRegionProvince || !selectedMunicipality || isTnBzCadastralFlow"
                      @click:clear="resetCadastralData('Sheets')"
                      @change="val => val && fillCadastralDataSelect('Sheets')"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    class="d-flex pb-0"
                  >
                    <v-autocomplete
                      v-model="selectedParcel"
                      :items="cadastral_data.parcels_list"
                      :item-text="item => getParcelNumber(item)"
                      :item-value="item => getParcelValue(item)"
                      :label="$t('Ticketing.cadastralSelect') + ' ' + $t('Ticketing.cadastralParcel')"
                      return-object
                      clearable
                      :disabled="!selectedRegionProvince || !selectedMunicipality || (!isTnBzCadastralFlow && !selectedSheet)"
                      @click:clear="resetCadastralData('Parcels')"
                      @change="val => val && fillCadastralDataSelect('Parcels')"
                    />
                  </v-col>
                </v-row>
              </div>
              <v-text-field
                v-if="!isComunale && !isProvinciale"
                v-model="placeName"
                :label="$t('Ticketing.address') + '*'"
                :disabled="true"
              />
              <div class="d-flex flex-column align-start">
                <v-btn
                  v-if="selectedAddressType === 'Manual'"
                  id="submit"
                  color="#0da344"
                  small
                  style="color:white"
                  :disabled="disableFindAddress"
                  @click="dispatchManualGeocoderMarker()"
                >
                  {{ $t('Ticketing.findAddress') }}
                </v-btn>
                <v-btn
                  v-if="selectedAddressType === 'Cadastral'"
                  id="submit-cadastral"
                  color="#0da344"
                  small
                  style="color:white"
                  :disabled="disableFindAddress"
                  @click="dispatchCadastralMarker()"
                >
                  {{ $t('Ticketing.findAddress') }}
                </v-btn>
                <v-btn
                  color="#0da344"
                  small
                  style="color:white"
                  class="my-2"
                  :disabled="checkForm()"
                  @click="addLocation()"
                >
                  {{ $t('Ticketing.addLocation') }}
                </v-btn>
              </div>
            </div>
            <v-alert
              :value="showMaxLimitMsg"
              dense
              type="warning"
              icon="mdi-alert-circle-outline"
              class="mt-4"
              transition="scale-transition"
            >
              {{ $t('Ticketing.maxPointsLimit') }}
            </v-alert>
            <v-data-table
              id="locations-table"
              :headers="ticketing.headers"
              :items="locationItems"
              :mobile-breakpoint="0"
              :footer-props="{
                itemsPerPageAllText: $t('Table.all'),
                itemsPerPageText: $t('Table.rowsPerPage'),
                pageText: `{0}-{1} ${$t('Table.of')} {2}`
              }"
              :no-data-text="$t('Table.noData')"
            >
              <template
                v-for="h in ticketing.headers"
                v-slot:[`header.${h.value}`]="{ header }"
              >
                {{ $t(header.text) }}
              </template>
              <template
                v-slot:[`item.start_date`]="{ item }"
              >
                <span>
                  {{ item.start_date ? moment(item.start_date).format('DD-MM-YYYY') : item.start_date }}
                </span>
              </template>
              <template
                v-slot:[`item.end_date`]="{ item }"
              >
                <span>
                  {{ item.end_date ? moment(item.end_date).format('DD-MM-YYYY') : item.end_date }}
                </span>
              </template>
              <template
                v-slot:[`item.latitude`]="{ item }"
              >
                <span>
                  {{ parseFloat(item.latitude).toFixed(2) }}
                </span>
              </template>
              <template
                v-slot:[`item.longitude`]="{ item }"
              >
                <span>
                  {{ parseFloat(item.longitude).toFixed(2) }}
                </span>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <delete
                  :id="item.name"
                  @deleted="deleteItem(item)"
                />
              </template>
              <template v-slot:[`item.meteo_type`]="{ item }">
                {{ splitMeteoOrDocumentType(item.meteo_type) }}
              </template>
            </v-data-table>
            <div
              v-if="canUseSplitEvasionLimits"
              class="mt-4 d-flex flex-wrap justify-space-between align-center"
            >
              <div class="ticketing-card-subtitle mr-4">
                <b>Modalità data limite evasione</b>
              </div>
              <v-btn-toggle
                v-model="evasionLimitMode"
                mandatory
                dense
                color="color_green"
              >
                <v-btn
                  small
                  value="single"
                >
                  Data unica
                </v-btn>
                <v-btn
                  small
                  value="split"
                >
                  Date per richiesta
                </v-btn>
              </v-btn-toggle>
            </div>
            <ticketing-priority-selection
              v-if="checkRequestManual && !isRelazione && !useSplitEvasionLimits"
              :required="isReport"
              :evasion-limit="evasion_limit"
              :location-items="locationItems"
              :is-provinciale="isProvinciale"
              :concurrent-request-count="concurrentRequestCount"
              :next-business-days="selectedNextBusinessDays"
              @update-evasion-limit="updateEvasionLimit($event)"
              @can-be-moved="canBeMoved($event)"
            />
            <ticketing-split-evasion-limit-selection
              v-if="canUseSplitEvasionLimits && evasionLimitMode === 'split'"
              :groups="splitRequestGroups"
              :evasion-limits="splitEvasionLimits"
              :can-be-moved-map="splitCanBeMovedMap"
              :is-provinciale="isProvinciale"
              @update:evasion-limits="splitEvasionLimits = $event"
              @update:can-be-moved-map="splitCanBeMovedMap = $event"
            />
            <document-s3-table
              :ticketing-path="true"
              :disable-form="false"
              :request-type="getBaseRequestType()"
            />
            <div class="d-flex align-center">
              <div class="ticketing-card-subtitle pr-4">
                <b>{{ $t('Ticketing.note') }}</b>
              </div>

              <v-tooltip
                v-if="selectedMeteoTypes.is_auto"
                right
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                    color="green darken-1"
                    v-on="on"
                  >
                    mdi-information-variant-circle-outline
                  </v-icon>
                </template>
                <div
                  class="my-1"
                  :style="{ 'max-width': '400px' }"
                >
                  <span>
                    {{ $t('Ticketing.tooltipNote') }}
                  </span>
                </div>
              </v-tooltip>
            </div>

            <v-textarea
              v-model="notes"
              class="mt-2"
              :counter="getBaseRequestType() === 'A' ? 100 : 512"
              :maxlength="getBaseRequestType() === 'A' ? 100 : 512"
              :disabled="hasSplitRequests"
              auto-grow
            />
            <v-alert
              :value="alert"
              color="red accent-4"
              dark
              transition="scale-transition"
            >
              extension file not allowed, please insert <b>.pdf</b>
            </v-alert>
            <div
              v-if="confirmIsDisabled"
              class="mt-4 error--text"
            >
              {{ $t('Ticketing.obligatoryMessage') }}
            </div>
            <div
              v-if="countHowManyRequests() > 1"
              class="mt-4 error--text"
            >
              {{ $t('Ticketing.countHowManyRequests', { count: countHowManyRequests() }) }}
            </div>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              color="#0da344"
              style="color:white"
              :disabled="confirmIsDisabled"
              @click="confirmRequest()"
            >
              {{ $t('Ticketing.confirm') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </div>
    </v-card>
    <div style="display: none;">
      <div
        id="popupCatasto"
        class="text-center"
      >
        <v-card
          v-if="showCatastoPopup"
          dark
        >
          <div class="px-3 pb-3 pt-1 text-left">
            <div class="div-overflow-y pt-2">
              <p
                v-if="map.catastoPopupData.DENOM"
                style="line-height: 1rem; white-space: nowrap;"
              >
                <strong>{{ map.catastoPopupData.DENOM }}</strong>
              </p>
              <div
                v-for="key in ['SEZIONE', 'FOGLIO', 'NUM_PART']"
                :key="key"
                style="line-height: 1rem; white-space: nowrap;"
              >
                <i v-if="map.catastoPopupData[key] && map.catastoPopupData[key].trim() !== ''">
                  {{ key === 'NUM_PART' ? 'PARTICELLA' : key }}: {{ map.catastoPopupData[key] }}
                </i>
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { getRegExp } from '@/formRules.js';
import { v4 as uuidv4 } from 'uuid';
import { fromLonLat, toLonLat } from 'ol/proj';
import Overlay from 'ol/Overlay';
import moment from 'moment-business-days';

export default {
  components: {
    DocumentS3Table: () => import('@/components/utils/DocumentS3Table'),
    delete: () => import('@/components/utils/Delete'),
    TicketingPrioritySelection: () => import('@/components/layout/TicketingPrioritySelection'),
    TicketingSplitEvasionLimitSelection: () => import('@/components/layout/TicketingSplitEvasionLimitSelection')
  },
  data() {
    return {
      ticket_id: '',
      selectedRegionProvince: null,
      selectedMunicipality: null,
      selectedSheet: null,
      selectedParcel: null,
      documentTypesList: [],
      meteoTypesList: [],
      pin: null,
      popupCatasto: null,
      autocomplete: null,
      newMap: null,
      country: '',
      latitude: '',
      longitude: '',
      notes: '',
      service_id: '',
      evasion_limit: '',
      evasionLimitMode: 'single',
      splitEvasionLimits: {},
      splitCanBeMovedMap: {},
      selectedAddressFromSelect: '',
      regionProvinceSearch: '',
      selectedAddressType: 'Address',
      valid: true,
      alert: false,
      rangeMenu: false,
      overlay: false,
      requestLimitReached: false,
      isManualCoordinates: false,
      isCadastralCoordinates: false,
      requestCanBeMoved: false,
      showMaxLimitMsg: false,
      isDatiCatastaliVisible: false,
      selectedDocumentTypes: {},
      selectedMeteoTypes: {},
      selectedMeteoTypesArray: [],
      number_rules: [...getRegExp('two_numbers_dot_only')],
      custom_rules: [],
      meteoTypes: [],
      rangeDate: [],
      selected: [],
      locationItems: [],
      checkRelazione: null,
      tooltipNoSelection: this.$t('Ticketing.tooltipNoSelection'),
      tooltipDataDocument: {
        relazione: {
          title: this.$t('Ticketing.relazione'),
          text: this.$t('Ticketing.tooltipRelazione')
        },
        comunale: {
          title: this.$t('Ticketing.comunale'),
          text: this.$t('Ticketing.tooltipComunale')
        },
        puntuale: {
          title: this.$t('Ticketing.puntuale'),
          text: this.$t('Ticketing.tooltipPuntuale')
        },
        provinciale: {
          title: this.$t('Ticketing.provinciale'),
          text: this.$t('Ticketing.tooltipProvinciale')
        }
      },
      tooltipDataMeteo: {
        colpoDiSole: {
          title: this.$t('Ticketing.colpoDiSole'),
          text: this.$t('Ticketing.tooltipColpoDiSole')
        },
        eccessoDiNeve: {
          title: this.$t('Ticketing.eccessoDiNeve'),
          text: this.$t('Ticketing.tooltipEccessoDiNeve')
        },
        eccessoDiPioggia: {
          title: this.$t('Ticketing.eccessoDiPioggia'),
          text: this.$t('Ticketing.tooltipEccessoDiPioggia')
        },
        fulminazione: {
          title: this.$t('Ticketing.fulminazione'),
          text: this.$t('Ticketing.tooltipFulminazione')
        },
        geloEBrina: {
          title: this.$t('Ticketing.geloEBrina'),
          text: this.$t('Ticketing.tooltipGeloEBrina')
        },
        sbalzoTermico: {
          title: this.$t('Ticketing.sbalzoTermico'),
          text: this.$t('Ticketing.tooltipSbalzoTermico')
        },
        ondataDiCalore: {
          title: this.$t('Ticketing.ondataDiCalore'),
          text: this.$t('Ticketing.tooltipOndataDiCalore')
        },
        ventoForte: {
          title: this.$t('Ticketing.ventoForte'),
          text: this.$t('Ticketing.tooltipVentoForte')
        },
        ventoCaldo: {
          title: this.$t('Ticketing.ventoCaldo'),
          text: this.$t('Ticketing.tooltipVentoCaldo')
        },
        grandine: {
          title: this.$t('Ticketing.grandine'),
          text: this.$t('Ticketing.tooltipGrandine')
        },
        siccità: {
          title: this.$t('Ticketing.siccità'),
          text: this.$t('Ticketing.tooltipSiccità')
        },
        siccitàSpei3: {
          title: this.$t('Ticketing.siccitàSpei3'),
          text: this.$t('Ticketing.tooltipSiccitàSpei3')
        },
        siccitàPgra2023: {
          title: this.$t('Ticketing.siccità'),
          text: this.$t('Ticketing.tooltipSiccità')
        },
        neveGiornaliera: {
          title: this.$t('Ticketing.neveGiornaliera'),
          text: this.$t('Ticketing.tooltipNeveGiornaliera')
        },
        precipitazione: {
          title: this.$t('Ticketing.precipitazione'),
          text: this.$t('Ticketing.tooltipPrecipitazione')
        },
        grandineGiornaliera: {
          title: this.$t('Ticketing.grandineGiornaliera'),
          text: this.$t('Ticketing.tooltipGrandineGiornaliera')
        },
        ventoGiornaliero: {
          title: this.$t('Ticketing.ventoGiornaliero'),
          text: this.$t('Ticketing.tooltipVentoGiornaliero')
        },
        temperaturaMinimaGiornaliera: {
          title: this.$t('Ticketing.temperaturaMinimaGiornaliera'),
          text: this.$t('Ticketing.tooltipTemperaturaMinimaGiornaliera')
        },
        temperaturaMassimaGiornaliera: {
          title: this.$t('Ticketing.temperaturaMassimaGiornaliera'),
          text: this.$t('Ticketing.tooltipTemperaturaMassimaGiornaliera')
        }
      },
      selectedTooltipDataDocument: {},
      selectedTooltipDataMeteo: {},
      ticketingTranslationConfig: []
    };
  },
  computed: {
    ...mapState(['policy', 'ticketing', 'file_transfer', 'app_user', 'map', 'cadastral_data']),
    rangeDateText() {
      const start_date = this.rangeDate[0] ? `${moment(this.rangeDate[0]).format('DD-MM-YYYY')},` : '';
      const end_date = this.rangeDate[1] ? `${moment(this.rangeDate[1]).format('DD-MM-YYYY')}` : '';

      return `${start_date} ${end_date}`;
    },
    calendarInfoText() {
      const text = this.$t('Ticketing.maxDateLimit');

      return this.isProvinciale ? text.replace('3', '1').replace('mesi', 'mese').replace('months', 'month') : text;
    },
    isRelazione() {
      return Object.keys(this.selectedDocumentTypes).length > 0 && this.$t(this.selectedDocumentTypes.document_type).toLowerCase().includes('relazione');
    },
    isComunale() {
      return Object.keys(this.selectedDocumentTypes).length > 0 && this.$t(this.selectedDocumentTypes.document_type).toLowerCase().includes('comunale');
    },
    isPuntuale() {
      return Object.keys(this.selectedDocumentTypes).length > 0 && this.$t(this.selectedDocumentTypes.document_type).toLowerCase().includes('puntuale');
    },
    isProvinciale() {
      return Object.keys(this.selectedDocumentTypes).length > 0 && this.$t(this.selectedDocumentTypes.document_type).toLowerCase().includes('provinciale');
    },
    isReport() {
      return Object.keys(this.selectedDocumentTypes).length > 0 && this.$t(this.selectedDocumentTypes.document_type).toLowerCase().includes('report');
    },
    availableRequestTypes() {
      if (!this.selectedMeteoTypes || Object.keys(this.selectedMeteoTypes).length === 0) {
        return [];
      }

      const { is_auto: isAuto, is_manual: isManual, is_approfondimento: isApprofondimento } = this.selectedMeteoTypes;
      const types = [];

      if (isAuto && !isManual) {
        types.push('A');

        if (isApprofondimento) {
          types.push('AM');
        }
      }

      if (isManual && !isAuto) {
        types.push('M');

        if (isApprofondimento) {
          types.push('MM');
        }
      }

      return types;
    },
    isLocationItemsSelected() {
      return this.locationItems.length > 0;
    },
    checkRequestManual() {
      // return (this.isReport && !this.selectedMeteoTypes.is_auto) || this.checkRequestType() === 'M';
      return this.isReport && this.checkRequestType() === 'M';
    },
    confirmIsDisabled() {
      if (this.isLocationItemsSelected) {
        if (this.useSplitEvasionLimits) {
          return !this.splitEvasionLimitsAreValid;
        }

        if (this.getBaseRequestType() !== 'A' || this.checkRequestType() === 'M') {
          return this.isReport ? !this.evasion_limit : false;
        }

        return false;
      }

      return true;
    },
    placeName() {
      return this.isProvinciale ? this.map.addressProv : this.map.address;
    },
    disableFindAddress() {
      if (this.valid) {
        if (this.selectedAddressType === 'Cadastral') {
          return this.isTnBzCadastralFlow ? !this.selectedParcel : !this.selectedSheet && !this.selectedParcel;
        }

        return this.selectedAddressType === 'Address' || (this.latitude === '' || this.longitude === '');
      }

      return !this.valid;
    },
    concurrentRequestCount() {
      const count = this.selectedMeteoTypesArray.filter(e => !e.is_auto).length;

      return this.isProvinciale ? 1 : count;
    },
    canUseSplitEvasionLimits() {
      return this.checkRequestManual && !this.isRelazione && this.splitRequestGroups.length > 1;
    },
    hasSplitRequests() {
      return this.splitRequestGroups.length > 1;
    },
    useSplitEvasionLimits() {
      return this.canUseSplitEvasionLimits && this.evasionLimitMode === 'split';
    },
    splitRequestGroups() {
      if (!Object.keys(this.selectedDocumentTypes).length || this.locationItems.length === 0) {
        return [];
      }

      const groupedByMeteoType = this.groupByMeteoType(this.locationItems);
      const splitGroups = this.groupByEndDate(groupedByMeteoType);

      return splitGroups.map((locations, index) => {
        const meteoType = this.getMeteoTypeFromLocations(locations);
        const nextBusinessDays = Number(meteoType?.next_business_days);
        const normalizedNextBusinessDays = Number.isInteger(nextBusinessDays) && nextBusinessDays >= 1 ? nextBusinessDays : 1;
        const pointEndDateIsNear = locations.some(location => moment(location.end_date).isSame(moment(), 'day'));
        const lastEndDate = moment.max(
          locations.map(location => moment(location.end_date, 'YYYY-MM-DD'))
        );
        const lastEndDateIsFridayOrSaturday = lastEndDate && [5, 6].includes(lastEndDate.isoWeekday());
        const effectiveNextBusinessDays = pointEndDateIsNear
          ? Math.max(normalizedNextBusinessDays, 2)
          : normalizedNextBusinessDays;

        return {
          key: String(index),
          locations,
          requestType: this.checkRequestType(locations),
          meteoTypeName: meteoType?.name || locations[0]?.meteo_type?.split(',')[0] || '',
          nextBusinessDays: normalizedNextBusinessDays,
          effectiveNextBusinessDays: lastEndDateIsFridayOrSaturday ? 1 : effectiveNextBusinessDays
        };
      });
    },
    splitEvasionLimitsAreValid() {
      if (!this.canUseSplitEvasionLimits) {
        return true;
      }

      return this.splitRequestGroups.every(group => {
        return group.requestType !== 'M' || !!this.splitEvasionLimits[group.key];
      });
    },
    selectedNextBusinessDays() {
      const selectedMeteoTypes = this.isComunale || this.isProvinciale
        ? [this.selectedMeteoTypes]
        : this.selectedMeteoTypesArray;
      const values = selectedMeteoTypes
        .map(item => Number(item.next_business_days))
        .filter(value => Number.isInteger(value) && value >= 1);

      return values.length > 0 ? Math.max(...values) : 1;
    },
    showCatastoPopup() {
      const properties = ['DENOM', 'SEZIONE', 'FOGLIO', 'NUM_PART'];

      return Object.keys(this.map.catastoPopupData).some(item => properties.includes(item));
    },
    formattedCadastralItems() {
      const items = [];

      this.cadastral_data.regions_and_provinces.forEach(region => {
        // Regione (non selezionabile)
        items.push({
          text: region.regionName,
          disabled: true
        });

        // Province (selezionabili)
        region.provinces.forEach(province => {
          items.push({
            text: province.provinceName,
            regionCode: region.regionCode,
            provinceCode: province.provinceCode,
            disabled: false
          });
        });
      });

      return items;
    },
    orderedSheets() {
      const collator = new Intl.Collator('it', { numeric: true, sensitivity: 'base' });

      return [...this.cadastral_data.sheets_list].sort((a, b) => {
        const fa = this.getSheetLabel(a);
        const fb = this.getSheetLabel(b);

        return collator.compare(fa, fb);
      });
    },
    isTnBzCadastralFlow() {
      return ['TN', 'BZ'].includes(this.selectedRegionProvince?.provinceCode);
    },
    filteredCadastralItems() {
      const search = (this.regionProvinceSearch || '').trim().toLowerCase();

      // Nessun testo digitato → mostro anche le regioni (header / disabled)
      if (!search) {
        return this.formattedCadastralItems;
      }

      // Con testo digitato → escludo le regioni (item.disabled === true)
      // e filtro solo le province sul testo
      return this.formattedCadastralItems.filter(item => {
        if (item.disabled) {
          return false;
        }

        return (item.text || '').toLowerCase().includes(search);
      });
    }
  },
  watch: {
    $route() {},
    hasSplitRequests(value) {
      if (value) {
        this.notes = '';
      }
    },
    '$route.params': {
      handler(newValue) {
        this.service_id = newValue.id;
      },
      immediate: true
    }
  },
  async mounted() {
    this.getRegionsAndProvincesList();
    await this.getTicketingConfiguration();
    // await this.getTicketingTranslation();

    this.map.landmark.setPosition(undefined);

    if (this.policy.enabledServicesPolicy.length == 0) {
      this.$router.push('/');
    }

    await this.checkTicketingRequestLimit();
    // eslint-disable-next-line no-undef
    this.autocomplete = new google.maps.places.Autocomplete(
      (this.$refs.autocomplete),
      { types: ['geocode'] }
    );

    this.autocomplete.addListener('place_changed', () => {
      const place = this.autocomplete.getPlace();
      this.map.address = place.formatted_address;
      this.map.ticketing_formatted_address = place.formatted_address;
      this.latitude = place.geometry.location.lat();
      this.longitude = place.geometry.location.lng();
    });

    this.checkMapPaddingSize();
    window.addEventListener('resize', this.checkMapPaddingSize);
  },
  beforeDestroy() {
    if (this.pin !== null) {
      this.pin.setPosition(undefined);
      this.pin = null;
    }

    if (this.popupCatasto !== null) {
      this.popupCatasto.setPosition(undefined);
      this.popupCatasto = null;
    }

    this.map.mapPadding = [0, 0, 0, 0];
    this.changeViewPadding();
    this.map.OLmap.un('click', this.enableManualGeocoder);
    window.removeEventListener('resize', this.checkMapPaddingSize);
  },
  methods: {
    ...mapActions(['listComuniProvinceAction', 'storeGetTicketingServiceConfiguration', 'storeGetTicketingServiceTranslation', 'createTicketingRequestAction', 'linkLocationToTicketingRequestAction', 'changeViewPadding', 'linkDocumentS3ToTicketingRequestAction', 'ticketingReverseGeocoding', 'listTicketingRequestLimitAction', 'resetDrawer', 'storeToastMessage', 'loadCatastoLayer', 'removeCatastoLayer', 'getRegionsAndProvincesList', 'getMunicipalityList', 'getSheetsList', 'getParcelsList', 'getMunicipalityParcelsList']),
    async getTicketingConfiguration() {
      this.overlay = true;
      await this.storeGetTicketingServiceConfiguration(this.service_id);
      this.overlay = false;

      this.ticket_id = this.ticketing.ticketingServiceConfiguration.ticket_id;

      if (this.ticketing.ticketingServiceConfiguration.config?.length > 0) {
        const checkPermissions = this.policy.ticketingServicePermissions.filter(e => e.permission_type === 'requests').map(e => e.permission_name.split(',')[0]);
        this.documentTypesList = JSON.parse(JSON.stringify(this.ticketing.ticketingServiceConfiguration.config.filter(e => checkPermissions.includes(e.document_type))));
      }
    },
    async getTicketingTranslation() {
      if (this.ticketing.ticketingServiceConfiguration.ticket_id) {

        const languageUsage = this.app_user.app_user_data[0].language.toLowerCase();

        const data = {
          ticket_id: this.ticketing.ticketingServiceConfiguration.ticket_id,
          lang: [languageUsage]
        };

        this.overlay = true;
        await this.storeGetTicketingServiceTranslation(data);
        this.overlay = false;

        this.ticketingTranslationConfig = this.ticketing.ticketingTranslationServiceConfiguration;
      }
    },
    updateSelectedTooltipDataDocument() {
      if (Object.keys(this.selectedDocumentTypes).length > 0) {
        const selectDocument = this.selectedDocumentTypes.document_type.toLowerCase();

        for (const key in this.tooltipDataDocument) {
          if (selectDocument.includes(key)) {
            this.selectedTooltipDataDocument = this.tooltipDataDocument[key];

            return;
          }
        }
      }
    },
    updateSelectedTooltipDataMeteo() {
      if (Object.keys(this.selectedMeteoTypes).length > 0) {
        const selectMeteo = this.selectedMeteoTypes?.name?.toLowerCase().replace(/\s|\(|\)/g, '');

        for (const key in this.tooltipDataMeteo) {
          if (selectMeteo === key.toLowerCase()) {
            this.selectedTooltipDataMeteo = this.tooltipDataMeteo[key];

            return;
          }
        }
      }
    },
    formatTooltipText(text) {
      const paragraphs = text.split('- ').filter(paragraph => paragraph.trim() !== '');
      const formattedText = paragraphs.map(paragraph => `<br> - ${paragraph}`).join('');

      return formattedText;
    },
    checkForm() {
      let requiredParams = this.valid && this.rangeDate.length > 1;
      requiredParams = requiredParams && this.latitude !== '' && this.longitude !== '';
      requiredParams = requiredParams && Object.keys(this.selectedDocumentTypes).length !== 0 && Object.keys(this.selectedMeteoTypes).length !== 0;
      requiredParams = requiredParams && !!this.map.ticketing_formatted_address;

      if (this.selectedAddressType === 'Cadastral') {
        requiredParams = this.isTnBzCadastralFlow
          ? requiredParams && this.selectedParcel !== null
          : requiredParams && (this.selectedSheet !== null || this.selectedParcel !== null);
      } else {
        requiredParams = this.isComunale || this.isProvinciale
          ? requiredParams && this.selectedAddressFromSelect !== ''
          : requiredParams && this.placeName !== '';
      }

      return !requiredParams;
    },
    closeDateRange() {
      this.rangeMenu = false;
      this.$refs.rangeMenu.save([]);
    },
    getCoordinatesFromAddress() {
      const normalize = (input) => {
        if (!input) {
          return input;
        }

        const match = input.match(/^(.*)\s*\(([^)]+)\)\s*$/);

        if (!match) {
          return input.trim();
        }

        const comune = match[1].trim();
        const provinciaCode = match[2].trim();

        return { comune, provinciaCode };
      };

      const tryFormats = (comune, provincia) => {
        return [
          `${comune}, ${provincia}`,
          `${comune}, ${provincia}, Italia`,
          `${comune}, ${provincia}, Italy`,
          `${comune}, Italia`,
          `${comune}, Italy`
        ];
      };

      const input = normalize(this.selectedAddressFromSelect);
      // eslint-disable-next-line no-undef
      const geocoder = new google.maps.Geocoder();

      const { comune, provinciaCode } = input;
      const attempts = tryFormats(comune, provinciaCode);

      const tryNext = (index = 0) => {
        if (index >= attempts.length) {
          this.storeToastMessage({
            text: 'Address not found: ' + this.selectedAddressFromSelect,
            type: 'error'
          });

          return;
        }

        geocoder
          .geocode({ address: attempts[index], language: 'it' })
          .then((response) => {
            if (!response || !response.results || !response.results.length) {
              return tryNext(index + 1);
            }

            const location = response.results[0].geometry.location;
            this.latitude = location.lat();
            this.longitude = location.lng();

            if (this.isProvinciale) {
              this.map.addressProv = this.selectedAddressFromSelect;
              this.map.ticketing_formatted_address = this.selectedAddressFromSelect;
            } else {
              this.map.address = this.selectedAddressFromSelect;
              this.map.ticketing_formatted_address = this.selectedAddressFromSelect;
            }
          })
          .catch(() => tryNext(index + 1));
      };

      tryNext();
    },
    autocompleteInit() {
      // eslint-disable-next-line no-undef
      this.autocomplete = new google.maps.places.Autocomplete(
        (this.$refs.autocomplete),
        { types: ['geocode'] }
      );

      this.autocomplete.addListener('place_changed', () => {
        const googlePlace = this.autocomplete.getPlace();
        let place = '';

        googlePlace.address_components.forEach(item => {
          if (item.types.includes('country')) {
            this.country = item.short_name;
          }

          if (this.isProvinciale && item.types[0] === 'administrative_area_level_2') {
            place = `${item.long_name.replace('Città Metropolitana di ', '').replace('Provincia di ', '')} (${item.short_name})`;
          } else {
            if (item.types[0] === 'administrative_area_level_3') {
              place += item.short_name;
            }

            if (place !== '' && item.types[0] === 'administrative_area_level_2') {
              place += ` (${item.short_name})`;
            }
          }
        });

        if (place === '') {
          place = googlePlace.formatted_address;
        }

        this.map.ticketing_formatted_address = googlePlace.formatted_address;
        this.map.address = place || 'SNC';
        this.map.addressProv = place || 'SNC';
        this.latitude = googlePlace.geometry.location.lat();
        this.longitude = googlePlace.geometry.location.lng();
      });
    },
    resetAddress() {
      this.invalidateResolvedLocation();
      this.latitude = '';
      this.longitude = '';
      this.map.address = '';
      this.map.addressProv = '';
      this.isManualCoordinates = false;
      this.clearCadastralData();

      if (this.pin !== null) {
        this.pin.setPosition(undefined);
      }

      if (this.popupCatasto !== null) {
        this.popupCatasto.setPosition(undefined);
      }
    },
    async dispatchManualGeocoderMarker() {
      this.invalidateResolvedLocation();
      await this.ticketingReverseGeocoding([this.longitude, this.latitude]);
      const lonLat = fromLonLat([this.longitude, this.latitude]);
      this.pin.setPosition(lonLat);
      this.map.OLmap.getView().setCenter(lonLat);
      this.isManualCoordinates = false;
      this.clearCadastralData();
    },
    dispatchCadastralMarker() {
      if (this.selectedParcel) {
        this.latitude = this.selectedParcel.lat;
        this.longitude = this.selectedParcel.lon;
      } else if (this.selectedSheet) {
        this.latitude = this.selectedSheet.lat;
        this.longitude = this.selectedSheet.lon;
      }

      const lonLat = fromLonLat([this.longitude, this.latitude]);
      this.pin.setPosition(lonLat);
      this.map.OLmap.getView().setCenter(lonLat);

      const foglio = this.isTnBzCadastralFlow ? '' : this.getSheetLabel(this.selectedSheet);
      const particella = this.selectedParcel ? this.getParcelNumber(this.selectedParcel) : '';

      this.map.address = this.getCadastralAddress();
      this.map.ticketing_formatted_address = this.map.address;

      this.map.catastoPopupData = {
        DENOM: this.selectedMunicipality ? this.toTitleCase(this.selectedMunicipality.name) : '',
        SEZIONE: '',
        FOGLIO: foglio,
        NUM_PART: particella
      };

      if (this.isDatiCatastaliVisible && this.popupCatasto !== null) {
        this.popupCatasto.setPosition(lonLat);
      }
    },
    addLocation() {
      const startDate = this.rangeDate[0];
      const endDate = this.rangeDate[1];

      this.locationItems.push({
        latitude: this.latitude,
        longitude: this.longitude,
        meteo_type: `${this.selectedMeteoTypes.name}, ServiceCard.${this.ticket_id}.${this.selectedMeteoTypes.meteo_id}.meteoType`,
        ticketing_formatted_address: this.map.ticketing_formatted_address,
        address: this.placeName,
        country: this.country,
        start_date: startDate,
        end_date: endDate
      });

      this.checkMaxPointsLimitMsg();
      this.updateMeteoTypesArray();

      this.invalidateResolvedLocation();
      this.latitude = '';
      this.longitude = '';
      this.map.address = '';
      this.map.addressProv = '';
      this.evasion_limit = '';
      this.selectedAddressFromSelect = '';
    },
    updateMeteoType() {
      this.updateSelectedTooltipDataMeteo();

      if (this.isProvinciale) {
        this.locationItems.forEach(item => {
          item.meteo_type = `${this.selectedMeteoTypes.name}, ServiceCard.${this.ticket_id}.${this.selectedMeteoTypes.meteo_id}.meteoType`;
        });
      }
    },
    updateMeteoTypesArray() {
      const alreadyAdded = this.selectedMeteoTypesArray.some(e => e.meteo_id === this.selectedMeteoTypes.meteo_id);

      if (!alreadyAdded) {
        this.selectedMeteoTypesArray.push(this.selectedMeteoTypes);
      }
    },
    splitMeteoOrDocumentType(item) {
      const documentOrMeteoSplitted = item.split(', ');
      const serviceCard = documentOrMeteoSplitted[1];

      return this.$t(serviceCard);
      // const [type] = item.split(', ');

      // return type;
    },
    deleteItem(item) {
      this.locationItems.splice(this.locationItems.indexOf(item), 1);

      if (!this.locationItems.some(e => e.meteo_type === item.meteo_type)) {
        this.selectedMeteoTypesArray.splice(this.selectedMeteoTypesArray.findIndex(e => e.name === item.meteo_type.split(',')[0]), 1);
      }

      this.evasion_limit = '';
      this.checkMaxPointsLimitMsg();
    },
    checkMaxPointsLimitMsg() {
      const maxPointsLimit = this.isProvinciale ? 1 : 5;
      this.showMaxLimitMsg = !this.isRelazione && this.locationItems.length >= maxPointsLimit;
    },
    updateMeteoTypeList() {
      this.ticketing.ticketingServiceConfiguration.config.forEach(element => {
        if (this.selectedDocumentTypes.document_id === element.document_id) {
          this.selectedMeteoTypes = {};
          this.meteoTypesList = [];
          element.meteo_types?.forEach(item => {
            this.meteoTypesList.push(item);
          });
        }
      });
    },
    async disableMarker() {
      if (this.isProvinciale || this.isComunale) {
        this.removeCatastoLayer();
        this.isDatiCatastaliVisible = false;
        this.overlay = true;
        await this.listComuniProvinceAction(this.isProvinciale);
        this.overlay = false;
      }

      this.updateMeteoTypeList();
      this.updateSelectedTooltipDataDocument();
      this.rangeDate = [];
      this.evasion_limit = '';
      this.locationItems = [];
      this.selectedMeteoTypesArray = [];
      this.checkMaxPointsLimitMsg();
      this.selectedAddressFromSelect = '';
      this.latitude = '';
      this.longitude = '';
      this.map.address = '';
      this.map.addressProv = '';

      const checkTimeRange = (time) => {
        const [start, end] = time;
        const startDate = new Date(start).getTime();
        const endDate = new Date(end).getTime();
        const result = (endDate - startDate) / (1000 * 3600 * 24);

        return result > 90;
      };

      if (!this.isRelazione && this.rangeDate.length > 1) {
        if (checkTimeRange(this.rangeDate)) {
          this.rangeDate = [];
        }
      }

      if (this.isPuntuale || this.isRelazione) {
        this.overlayConfig();
        this.popupCatastoConfig();
        this.map.OLmap.on('click', this.enableManualGeocoder);
      } else {
        if (this.pin !== null) {
          this.pin.setPosition(undefined);
          this.pin = null;
        }

        if (this.popupCatasto !== null) {
          this.popupCatasto.setPosition(undefined);
          this.popupCatasto = null;
        }

        this.latitude = '';
        this.longitude = '';
        this.map.address = '';
        this.map.addressProv = '';
        this.map.OLmap.un('click', this.enableManualGeocoder);
      }
    },
    checkRequestType(locations) {
      let requestType = '';
      const locationItems = [];

      if (locations) {
        const config = this.ticketing.ticketingServiceConfiguration.config.find(e => e.document_id === this.selectedDocumentTypes.document_id);
        const meteoType = config.meteo_types.find(e => e.meteo_id === locations[0].meteo_type.split('.')[2]);

        requestType = !meteoType.is_auto ? 'M' : 'A';
        locationItems.push(...locations);
      } else {
        const checkMultipleMeteoTypes = this.selectedMeteoTypesArray.some(e => !e.is_auto) ? 'M' : 'A';
        const checkSingleMeteoTypes = this.selectedMeteoTypes.is_auto ? 'A' : 'M';

        requestType = this.isProvinciale ? checkSingleMeteoTypes : checkMultipleMeteoTypes;
        locationItems.push(...this.locationItems);
      }

      const date_limit = this.ticketing.ticketingServiceConfiguration.date_limit;
      const toBeManual = locationItems.some(e => {
        if (!this.isComunale && !this.isProvinciale) {
          const isCadastralAddress = e.ticketing_formatted_address?.includes('fg.') || e.ticketing_formatted_address?.includes('p.lla');

          const isOutsideItaly = !isCadastralAddress && !e.ticketing_formatted_address?.includes('Italia') && !e.ticketing_formatted_address?.includes('Italy') && !e.ticketing_formatted_address?.includes('Italien');
          // const isOutsideItaly = e.country !== 'IT';

          return e.start_date < date_limit || e.address === 'SNC' || isOutsideItaly;
        }

        return e.start_date < date_limit || e.address === 'SNC';
      });

      return toBeManual ? 'M' : requestType;
    },
    getBaseRequestType() {
      if (!this.selectedMeteoTypes || Object.keys(this.selectedMeteoTypes).length === 0) {
        return '';
      }

      return this.selectedMeteoTypes.is_auto ? 'A' : 'M';
    },
    groupByMeteoType(array) {
      const gruppi = array.reduce((acc, item) => {
        const meteo_type = item.meteo_type;

        if (!acc[meteo_type]) {
          acc[meteo_type] = [];
        }

        acc[meteo_type].push(item);

        return acc;
      }, {});

      return Object.values(gruppi);
    },
    getMeteoTypeFromLocations(locations) {
      const config = this.ticketing.ticketingServiceConfiguration.config.find(
        e => e.document_id === this.selectedDocumentTypes.document_id
      );

      return config?.meteo_types.find(
        e => e.meteo_id === locations[0].meteo_type.split('.')[2]
      );
    },
    groupByEndDate(locationGroups) {
      if (this.isRelazione) {
        return locationGroups;
      }

      const result = {};
      const type = this.isPuntuale ? 'puntuale' : 'comunale';
      const checkDate = moment(this.ticketing.ticketingServiceConfiguration.check_date[type], 'YYYY-MM-DD');

      for (const [groupKey, locations] of Object.entries(locationGroups)) {
        const meteoType = this.getMeteoTypeFromLocations(locations);

        if (!meteoType.is_auto) {
          result[groupKey] = [locations];
        } else {
          const validLocations = [];
          const futureLocationMap = {}; // { end_date: [locations] }

          locations.forEach(location => {
            const endDate = moment(location.end_date, 'YYYY-MM-DD');

            if (endDate.isSameOrBefore(checkDate)) {
              validLocations.push(location);
            } else {
              if (!futureLocationMap[endDate]) {
                futureLocationMap[endDate] = [];
              }

              futureLocationMap[endDate].push(location);
            }
          });

          const splitGroup = [];

          if (validLocations.length > 0) {
            splitGroup.push(validLocations);
          }

          Object.values(futureLocationMap).forEach(group => {
            splitGroup.push(group);
          });

          result[groupKey] = splitGroup;
        }
      }

      return Object.values(result).flat();
    },
    countHowManyRequests() {
      if (Object.keys(this.selectedDocumentTypes).length) {
        const locationDataMT = this.groupByMeteoType(this.locationItems);
        const locationData = this.groupByEndDate(locationDataMT);

        return locationData.length;
      }

      return 0;
    },
    async confirmRequest() {
      const locationDataMT = this.groupByMeteoType(this.locationItems);
      const locationData = this.groupByEndDate(locationDataMT);

      for await (const [index, location] of locationData.entries()) {
        if (index > 0) {
          this.ticketing.request_id = uuidv4();
        }

        const splitGroup = this.splitRequestGroups[index];
        const evasionLimit = this.useSplitEvasionLimits
          ? this.splitEvasionLimits[splitGroup.key]
          : this.evasion_limit;
        const canBeMoved = this.useSplitEvasionLimits
          ? this.splitCanBeMovedMap[splitGroup.key]
          : this.requestCanBeMoved;

        await this.elaborateRequest(location, evasionLimit, canBeMoved);
      }

      this.$router.push({
        name: 'TicketingRequestList',
        params: { id: this.service_id }
      });
    },
    async elaborateRequest(locationData, evasionLimit, canBeMoved) {
      const translatedDocumentType = `${this.selectedDocumentTypes.document_type}, ServiceCard.${this.ticket_id}.${this.selectedDocumentTypes.document_id}.documentType`;
      const node_name = this.policy.ticketingServicePermissions[0].node_name;
      const surname = this.policy.ticketingServicePermissions[0].surname;
      const email = this.policy.ticketingServicePermissions[0].email;
      const phone = this.policy.ticketingServicePermissions[0].phone;
      const crm_id = this.policy.ticketingServicePermissions[0].crm_id;
      const ragione_sociale = this.policy.ticketingServicePermissions[0].ragione_sociale;
      const _name = this.policy.ticketingServicePermissions[0]._name;

      locationData.forEach(location => {
        location.app_user_ticket_id = this.ticketing.app_user_ticket_id,
        location.request_id = this.ticketing.request_id;
        location.location_id = uuidv4();
      });

      const single_notification = this.policy.ticketingServicePermissions.some(item => item.permission_name === 'Invio notifica al singolo utente');
      const group_notification = this.policy.ticketingServicePermissions.some(item => item.permission_name === 'Invio notifica di gruppo');
      const send_notification = single_notification || group_notification;

      const requestData = {
        app_user_ticket_id: this.ticketing.app_user_ticket_id,
        request_id: this.ticketing.request_id,
        request_type: this.checkRequestType(locationData),
        document_type: translatedDocumentType,
        username: this.app_user.username,
        evasion_date: '',
        evasion_limit: this.checkRequestType(locationData) === 'M' ? evasionLimit : '',
        request_date: moment().format('YYYY-MM-DD'),
        request_state: 'SENT',
        notes: this.hasSplitRequests ? '' : this.notes || '',
        node_name: node_name,
        surname: surname,
        email: email,
        phone: phone,
        crm_id: crm_id,
        ragione_sociale: ragione_sociale,
        _name: _name,
        locations: JSON.parse(JSON.stringify(locationData)),
        send_email: send_notification,
        group_notification: group_notification,
        can_be_moved: canBeMoved || false
      };

      requestData.locations.forEach(element => {
        delete element.ticketing_formatted_address;
        delete element.country;
      });

      this.overlay = true;
      await this.createTicketingRequestAction(requestData);

      if (this.ticketing.createRequestState) {
        await this.linkLocationToTicketingRequestAction(requestData.locations);

        if (this.ticketing.documentS3ItemsAppUser.length > 0) {
          const documents = this.ticketing.documentS3ItemsAppUser.map(e => {
            return {
              ...e,
              request_id: requestData.request_id,
              request_type: requestData.request_type,
              document_s3_id: uuidv4()
            };
          });
          await this.linkDocumentS3ToTicketingRequestAction(documents);
        }
      }

      this.ticketing.documentS3ItemsAppUser = [];
      this.overlay = false;
    },
    getCalendarMaxDate() {
      const todayDate = moment();
      const startDate = moment(this.rangeDate[0]);
      const monthsLimit = this.isProvinciale ? 1 : 3;
      const maxDate = moment(startDate).add(monthsLimit, 'months');

      return moment.min([todayDate, maxDate]).format('YYYY-MM-DD');

      // let subtractedDate;
      // let limitDate;

      // if (!this.isRelazione && this.selectedMeteoTypes.is_auto) {
      //   const hour = this.isPuntuale ? 14 : 18;
      //   const referenceTime = moment().set('hour', hour).set('minute', 0).set('second', 0);

      //   const days = referenceTime && moment().isBefore(referenceTime) ? 3 : 2;
      //   subtractedDate = moment(todayDate).subtract(days, 'days');
      //   limitDate = moment.min([subtractedDate, maxDate]);
      // } else {
      //   limitDate = moment.min([todayDate, maxDate]);
      // }

      // return moment(limitDate).format('YYYY-MM-DD');
    },
    canBeMoved(prevFreeSlots) {
      this.requestCanBeMoved = !this.isProvinciale && !this.isRelazione && !prevFreeSlots;
    },
    updateEvasionLimit(value) {
      this.evasion_limit = value;
    },
    async checkTicketingRequestLimit() {
      await this.listTicketingRequestLimitAction(this.app_user.crm_id);
      const findCrm = this.ticketing.ticketingRequestLimit.find(e => e.crm_id === this.app_user.crm_id);
      this.requestLimitReached = findCrm ? findCrm.limit_reached : false;
    },
    async handleDatiCatastali(value) {
      if (value) {
        this.overlay = true;
        const view = this.map.OLmap.getView();
        const actualZoom = view.getZoom();

        if (actualZoom < 14.5) {
          view.animate({
            zoom: 14.5,
            duration: 200
          });
        }

        await this.loadCatastoLayer();
        this.overlay = false;
      } else {
        this.popupCatasto.setPosition(undefined);
        await this.removeCatastoLayer();
      }
    },
    overlayConfig() {
      this.pin = new Overlay({
        positioning: 'bottom-center',
        element: document.getElementById('pin'),
        stopEvent: false
      });
      this.map.OLmap.addOverlay(this.pin);
    },
    popupCatastoConfig() {
      this.popupCatasto = new Overlay({
        positioning: 'bottom-center',
        offset: [0, -30],
        element: document.getElementById('popupCatasto'),
        stopEvent: false
      });
      this.map.OLmap.addOverlay(this.popupCatasto);
    },
    enableManualGeocoder(e) {
      if (this.selectedAddressType === 'Cadastral') {
        if (this.isDatiCatastaliVisible) {
          if (this.pin !== null) {
            this.pin.setPosition(e.coordinate);
          }

          if (this.popupCatasto !== null) {
            this.popupCatasto.setPosition(e.coordinate);
          }
        }

        return;
      }

      const lonLat = toLonLat(e.coordinate);
      this.invalidateResolvedLocation();
      this.latitude = lonLat[1];
      this.longitude = lonLat[0];
      this.pin.setPosition(e.coordinate);
      this.ticketingReverseGeocoding(lonLat);

      if (this.isDatiCatastaliVisible && this.popupCatasto !== null) {
        this.popupCatasto.setPosition(e.coordinate);
      }
    },
    checkMapPaddingSize() {
      const element = document.getElementById('rightBar');
      const width = element?.offsetWidth;
      this.map.mapPadding = [0, width - 40, 0, 0];
      this.changeViewPadding();
    },
    isLandscape() {
      return /Mobi|Android/i.test(navigator.userAgent) && window.innerHeight < window.innerWidth;
    },
    mobileBreakpoints() {
      return /Mobi|Android/i.test(navigator.userAgent) || this.isLandscape();
    },
    async fillCadastralDataSelect(type) {
      this.invalidateResolvedLocation();
      this.overlay = true;

      if (type === 'RegionProvince') {
        this.resetCadastralData('Municipality');
        await this.getMunicipalityList(this.selectedRegionProvince);
      }

      if (type === 'Municipality') {
        this.resetCadastralData('Sheets');

        if (this.isTnBzCadastralFlow) {
          await this.getMunicipalityParcelsList({
            municipalityCode: this.selectedMunicipality.code,
            provinceCode: this.selectedRegionProvince.provinceCode
          });
        } else {
          await this.getSheetsList(this.selectedMunicipality.code);
        }
      }

      if (type === 'Sheets') {
        this.resetCadastralData('Parcels');
        await this.getParcelsList({
          municipalityCode: this.selectedMunicipality.code,
          sheetCode: this.selectedSheet.sheetId,
          regionCode: this.selectedRegionProvince?.regionCode
        });
        this.map.address = `${this.toTitleCase(this.selectedMunicipality.name)} (${this.selectedRegionProvince.provinceCode}) - fg. ${this.getSheetLabel(this.selectedSheet)}`;
        this.latitude = this.selectedSheet.lat;
        this.longitude = this.selectedSheet.lon;
      }

      if (type === 'Parcels') {
        this.map.address = this.getCadastralAddress();
        this.latitude = this.selectedParcel.lat;
        this.longitude = this.selectedParcel.lon;
      }

      this.overlay = false;
    },
    resetCadastralData(type) {
      if (type === 'RegionProvince') {
        this.selectedRegionProvince = null;
        this.selectedMunicipality = null;
        this.selectedSheet = null;
        this.selectedParcel = null;
      }

      if (type === 'Municipality') {
        this.selectedMunicipality = null;
        this.selectedSheet = null;
        this.selectedParcel = null;
      }

      if (type === 'Sheets') {
        this.selectedSheet = null;
        this.selectedParcel = null;
      }

      if (type === 'Parcels') {
        this.selectedParcel = null;
      }

      if (type === 'Parcels' && this.selectedSheet) {
        this.map.address = `${this.toTitleCase(this.selectedMunicipality.name)} (${this.selectedRegionProvince.provinceCode}) - fg. ${this.getSheetLabel(this.selectedSheet)}`;
        this.latitude = this.selectedSheet.lat;
        this.longitude = this.selectedSheet.lon;
      } else {
        this.map.address = '';
        this.latitude = '';
        this.longitude = '';
      }
    },
    clearCadastralData() {
      this.isCadastralCoordinates = false;
      this.selectedRegionProvince = null;
      this.selectedMunicipality = null;
      this.selectedSheet = null;
      this.selectedParcel = null;
    },
    invalidateResolvedLocation() {
      this.map.ticketing_formatted_address = '';
    },
    getSheetLabel(item) {
      const sheetId = item?.sheetId || '';

      return this.isTnBzCadastralFlow ? sheetId : this.formatFoglio(sheetId);
    },
    getParcelValue(item) {
      return this.isTnBzCadastralFlow ? `${item?.sheetId || ''}:${item?.parcelId || ''}` : item?.parcelId;
    },
    getParcelNumber(item) {
      const parcelId = item?.parcelId || '';

      if (typeof parcelId !== 'string') {
        return parcelId;
      }

      const normalized = parcelId.trim();

      if (!normalized) {
        return normalized;
      }

      if (this.isTnBzCadastralFlow) {
        return normalized;
      }

      return normalized.includes('.') ? normalized.split('.').pop() : normalized;
    },
    getCadastralAddress() {
      const municipalityName = this.toTitleCase(this.selectedMunicipality.name);
      const provinceCode = this.selectedRegionProvince.provinceCode;

      if (this.isTnBzCadastralFlow) {
        return `${municipalityName} (${provinceCode}) - p.lla ${this.getParcelNumber(this.selectedParcel)}`;
      }

      if (this.selectedParcel) {
        return `${municipalityName} (${provinceCode}) - fg. ${this.getSheetLabel(this.selectedSheet)} p.lla ${this.getParcelNumber(this.selectedParcel)}`;
      }

      return `${municipalityName} (${provinceCode}) - fg. ${this.getSheetLabel(this.selectedSheet)}`;
    },
    formatFoglio(raw) {
      if (!raw || typeof raw !== 'string') {
        return raw;
      }

      const codice = raw.trim();

      if (!codice) {
        return codice;
      }

      // 1) Estrai D e il resto
      let sezione = null;
      let rest = codice;

      const firstChar = codice[0];

      if (/[A-Za-z]/.test(firstChar)) {
        // D è una lettera: è la sezione
        sezione = firstChar.toUpperCase();
        rest = codice.slice(1); // 6 caratteri successivi
      }

      // 2) Normalizza rest a 6 caratteri
      if (rest.length < 6) {
        rest = rest.padStart(6, '0');
      } else if (rest.length > 6) {
        rest = rest.slice(-6);
      }

      // Pattern: N N N N X Y (su 'rest')
      const nnnn = rest.slice(0, 4); // 4 caratteri centrali
      const x = rest[4];
      const y = rest[5];

      // 3) Numero foglio: rimuovi zeri iniziali da NNNN
      let numero = nnnn.replace(/^0+/, '');

      if (numero === '') {
        numero = '0';
      }

      // 4) Suffisso da X/Y
      let suffix = '';

      if (x === '0' && y === '0') {
        // nessun suffisso
        suffix = '';
      } else if (x === '0' && y !== '0') {
        // penultima 0, ultima diversa da 0 => "_Y"
        suffix = '_' + y;
      } else {
        // x !== "0"
        if (y === '0') {
          suffix = x;
        } else {
          suffix = x + y;
        }
      }

      let formatted = numero + suffix;

      // 5) Sezione
      if (sezione) {
        formatted += ` Sez.${sezione}`;
      }

      return formatted;
    },
    toTitleCase(str) {
      if (!str || typeof str !== 'string') {
        return str;
      }

      const lower = str.toLowerCase();

      let formatted = lower.replace(/(^.|[\s-].)/g, (match) => match.toUpperCase());

      if (formatted === 'L\'aquila') {
        formatted = 'L\'Aquila';
      }

      return formatted;
    }
  }
};
</script>

<style scoped>
#rightBar {
  height: 100%!important;
}
#popupCatasto > .v-card {
  max-width: 450px;
  margin-bottom: 25px;
  /* outline-offset: -5px;
  outline: 3px solid #00A644; */
  opacity: 0.95;
  font-family: 'Open Sans', sans-serif;
}
#popupCatasto > .v-card::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  opacity: 0.90;
  margin-left: -15px;
  border-width: 15px;
  border-style: solid;
  border-color: #000 transparent transparent transparent;
}
.div-overflow-y{
  max-height: 300px;
  overflow-y: auto;
  scrollbar-width: thin;
}
.top-component-class {
  position: fixed;
  right: 0em;
  top: 0em;
  max-height: 100vh;
  width: 50%;
  z-index: 4;
  overflow: auto;
}
.ticketing-card-title {
  color: #0da344;
  background-color: #f4f3f3;
  margin-top: 1%;
  font-size: 22px;
}
::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  font-size: 16px;
}
.search-location {
  width: 100%;
  border: 0;
  margin-top:1%;
  margin-bottom: 2%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.40);
}
.search-location:focus {
  outline: none;
}
.ticketing-card-subtitle{
  font-size: 18px;
}
input[type="text"] {
  font-size:16px;
}
#locations-table {
  white-space: nowrap !important;
}
@media (max-width: 600px), (max-height: 600px) and (orientation: landscape){
  .top-component-class {
    width: 100%;
  }
  .mobile-margin{
    margin-left: 40px !important;
  }
  .slider {
    height: calc(100% - 64px);
    overflow-y: auto;
    padding-bottom: 12px;
  }
}
</style>
